module.exports = __webpack_public_path__ + "kudos_50.svg?49cbb3cf81aa182c1f6b4fce75303a6a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_50.svg
// module id = 151
// module chunks = 0